import React from 'react';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import PropTypes from 'prop-types';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';
import ActionItem
  from 'Components/ComponentLibrary/Organisms/UpNextTaskingPicker/UpNextTasking/ActionItems/ActionItemList/Content/ActionItem';
import ListItemContainer from './ActionItem/ListItem/ListItemContainer';

const useStyles = makeStyles(() => ({
  alternativeForm: {
    flexBasis: '100%',
  },
}));

const Layout = (actionItemListItemProps) => {
  const {
    alternativeToggleDisplay,
    markAsComplete,
    refreshActionItems,
  } = actionItemListItemProps;
  const classes = useStyles();
  let AlternativeForm = null;
  if (alternativeToggleDisplay) {
    const valid = false;
    const fileCollection = null;
    const formResource = null;
    const formLayout = null;
    const submitLabelOverride = '';
    const displaySuccessLabel = '';

    AlternativeForm = valid && (
      <MetaFormInline
        className={classes.alternativeForm}
        classes={{
          root: classes.alternativeForm,
          fieldListControlNotFirst: classes.alternativeFormFieldListControl,
        }}
        resource={formResource}
        onSubmit={() => {
          return fileCollection.refresh().then(() => {
            displaySuccess(displaySuccessLabel);
            markAsComplete();
            return refreshActionItems();
          });
        }}
        onFailure={err => displayErrorMessage(err, err.errors)}
        fullWidth
        layout={formLayout}
        submitLabelOverride={submitLabelOverride}
      />
    );
  }

  return (
    <ActionItem
      AlternativeForm={AlternativeForm}
      {...actionItemListItemProps}
    />
  );
};

// NOTE: This file was created to isolate and reuse existing brittle code
export default function ListItemContainerWrapper({ resource, replaceActionItem, refreshActionItems }) {
  return (
    <ListItemContainer resource={resource} refreshActionItems={refreshActionItems} replaceActionItem={replaceActionItem} Component={Layout} />
  );
}

ListItemContainerWrapper.propTypes = {
  resource: PropTypes.object.isRequired,
  replaceActionItem: PropTypes.func.isRequired,
  refreshActionItems: PropTypes.func.isRequired,
};
